import { Box, Stack } from "@mui/material";
import { Title } from "@src/appV2/redesign/system/ui-components";
import { isRebrandingEnabled } from "@src/appV2/redesign/system/ui-theme";

import { SlideTextContainer } from "../../components/SlideTextContainer";
import { SHIFT_CARDS, ShiftCard, ShiftDetailsButton } from "./ShiftCard";

export function InstantBookSlide() {
  return (
    <Box
      sx={{
        height: "100%",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Box
        sx={{
          flex: 58,
          position: "relative",
          overflow: "hidden",
          minHeight: 0,
          display: "flex",
          justifyContent: "center",
        }}
      >
        <Box sx={{ width: 310 }}>
          <Stack
            spacing="9.971px"
            sx={{
              paddingBottom: "36.257px",
              borderBottom: "0.906px solid rgba(0, 0, 0, 0.07)",
            }}
          >
            {SHIFT_CARDS.map((card) => (
              <ShiftCard key={card.id} data={card} />
            ))}
            <ShiftDetailsButton />
          </Stack>
        </Box>
        <Box
          sx={(theme) => ({
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            height: "25%",
            // eslint-disable-next-line cbh-rules/no-inline-gradient -- TODO: migrate to theme palette gradient
            background: `linear-gradient(to bottom, ${isRebrandingEnabled() ? theme.palette.background.tertiary : theme.palette.background.quaternary} 0%, ${isRebrandingEnabled() ? theme.palette.background.tertiary : "rgba(250, 248, 247, 0.8)"} 20%, ${isRebrandingEnabled() ? "transparent" : "rgba(250, 248, 247, 0.4)"} 60%, transparent 100%)`,
            pointerEvents: "none",
          })}
        />
        <Box
          sx={(theme) => ({
            position: "absolute",
            bottom: 0,
            left: 0,
            right: 0,
            height: "35%",
            // eslint-disable-next-line cbh-rules/no-inline-gradient -- TODO: migrate to theme palette gradient
            background: `linear-gradient(to bottom, transparent 0%, ${isRebrandingEnabled() ? theme.palette.background.tertiary : "rgba(250, 248, 247, 0.7)"} 20%, ${isRebrandingEnabled() ? theme.palette.background.tertiary : "rgba(250, 248, 247, 0.95)"} 50%, ${isRebrandingEnabled() ? theme.palette.background.tertiary : theme.palette.background.quaternary} 100%)`,
            pointerEvents: "none",
          })}
        />
      </Box>

      <SlideTextContainer>
        <Stack spacing={0} alignItems="center" sx={{ margin: 0 }}>
          <Title variant="h3" component="h1" sx={{ textAlign: "center", margin: 0 }}>
            Claim individual shifts
          </Title>
          <Title variant="h3" component="h2" sx={{ textAlign: "center", margin: 0 }}>
            instantly to build your
          </Title>
          <Title variant="h3" component="h2" sx={{ textAlign: "center", margin: 0 }}>
            own schedule
          </Title>
        </Stack>
      </SlideTextContainer>
    </Box>
  );
}
